import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseQueryWithMaintenance = (baseQueryOptions = {}) => {
  const baseQuery = fetchBaseQuery(baseQueryOptions);
  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    if (result?.error?.status === 503) {
      if (
        typeof window !== "undefined" &&
        window.__TRIGGER_SERVER_MAINTENANCE__
      ) {
        window.__TRIGGER_SERVER_MAINTENANCE__(result?.error?.message || {});
      }
    }
    return result;
  };
};
